import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { IconButton, useTheme } from '@mui/material';
import { FC } from 'react';


interface WbTableRowEditButtonProps {
  onClick: () => void;
}

export const WbTableRowEditButton: FC<WbTableRowEditButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
		<IconButton
			sx={{
				'&:hover': {
					background: theme.colors.primary.lighter,
				},
				'color': theme.palette.primary.main,
			}}
			color="inherit"
			size="small"
			onClick={onClick}>
			<EditTwoToneIcon fontSize="small" />
		</IconButton>
	)
};
